var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_565_1949)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6732 18.2884C16.6732 21.9033 14.2377 24.3928 11.7346 24.3928C9.23191 24.3928 6.79687 21.9036 6.79687 18.2884C6.79687 14.6736 9.23181 12.1846 11.7346 12.1846C14.2378 12.1846 16.6732 14.6738 16.6732 18.2884Z",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2931 30.4166L18.2925 30.417C16.5082 31.5061 14.9089 32.8269 13.5232 34.3287H2.59346C2.25161 34.3287 1.92751 34.1678 1.71915 33.8924C1.51141 33.6165 1.44627 33.2597 1.53995 32.9339L1.54025 32.9328C2.25633 30.4355 3.88218 28.3192 6.03835 26.9592C7.59665 28.3219 9.56564 29.1672 11.7351 29.1672C13.7863 29.1672 15.5799 28.3681 17.0621 27.249C17.3844 28.377 17.8136 29.4113 18.3456 30.3851C18.3281 30.3955 18.3106 30.406 18.2931 30.4166Z",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2625 24.3928C45.7594 24.3928 43.3242 21.9035 43.3242 18.2884C43.3242 14.6737 45.7593 12.1846 48.2625 12.1846C50.7659 12.1846 53.2005 14.6736 53.2005 18.2884C53.2005 21.9036 50.7658 24.3928 48.2625 24.3928Z",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7048 30.417L41.7043 30.4166C41.6868 30.406 41.6693 30.3955 41.6518 30.385C42.1838 29.4112 42.613 28.3769 42.9354 27.2488C44.4175 28.368 46.2109 29.1672 48.2623 29.1672C50.4315 29.1672 52.4007 28.3219 53.9592 26.9592C56.1157 28.3193 57.7416 30.4356 58.4571 32.9326L58.4573 32.9334C58.551 33.2597 58.4858 33.6166 58.2787 33.8923C58.0697 34.1682 57.7456 34.3287 57.4045 34.3287H46.4742C45.0886 32.8269 43.4895 31.5061 41.7048 30.417Z",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0987 44.6554L46.0988 44.656C46.314 45.4059 46.1643 46.2136 45.6935 46.839C45.2228 47.4629 44.4878 47.8285 43.7064 47.8285H15.9495C15.1702 47.8285 14.4348 47.4624 13.9625 46.8379C13.4919 46.2122 13.3424 45.4037 13.5569 44.6567L13.5571 44.656C14.7358 40.544 17.4414 37.0754 21.0215 34.8893L21.0222 34.8889C21.2087 34.7748 21.4443 34.7974 21.6049 34.9424L21.6054 34.9429C23.8977 37.0118 26.803 38.2858 29.9982 38.2858C33.1314 38.2858 35.9869 37.0599 38.258 35.0597L38.2583 35.0594C38.4191 34.9177 38.6581 34.8972 38.8436 35.014C42.3205 37.2061 44.9433 40.6222 46.0987 44.6554Z",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3925 22.3699C38.3925 28.2392 34.4099 32.5564 29.9982 32.5564C25.5869 32.5564 21.6045 28.2393 21.6045 22.3699C21.6045 16.5001 25.5867 12.1846 29.9982 12.1846C34.4103 12.1846 38.3925 16.5005 38.3925 22.3699Z",
    stroke: "white",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_565_1949"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.30216240b8f3ff6c3fc04bdc85d17483.svg";
export { ForwardRef as ReactComponent };